<template>
  <v-row dense>
    <v-col xs="12" sm="12" md="12" lg="12">
      <v-row dense>
        <v-col xs="12" sm="12" md="12" lg="12">
          <v-card color="primary" class="ma-2">
            <v-data-table
              :headers="headers"
              :items="items"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Users</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="() => $refs.UserCreationDialog.open()"
                  >
                    Create new User
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:no-data>No data</template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <tasks-table-stats
                    :stats="item.statistics"
                    :status="item.status"
                  />
                </td>
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatDateWithTime(item.start) }}
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon color="error" @click="remove(item)">
                  mdi-trash-can
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <UserCreationDialog
      :type="'uploads'"
      @onCreate="onCreate"
      ref="UserCreationDialog"
    ></UserCreationDialog>
  </v-row>
</template>

<script>
import { DateTimeFormatter } from '../shared/DateTime.formatter';

import { Axios } from '../services';
import UserCreationDialog from '../components/users/UserCreationDialog';
export default {
  data: () => ({
    headers: [
      {
        text: 'ID',
        align: 'start',
        sortable: true,
        value: 'id'
      },
      { text: 'Name', value: 'name' },
      { text: 'E-mail', value: 'email' },
      { text: 'Created', value: 'created_at' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    items: []
  }),
  created() {
    return this.getList();
  },
  components: { UserCreationDialog },
  methods: {
    formatDateWithTime(date) {
      return DateTimeFormatter.formatWithTime(date);
    },
    onCreate() {
      this.getList();
    },
    remove(user) {
      Axios.Api.delete(`/v1/users/${user.id}`).then(() => this.getList());
    },
    getList() {
      Axios.Api.get('/v1/users', {}).then((res) => {
        this.items = res.items;
      });
    }
  }
};
</script>

<style lang="scss"></style>
